import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'config/axios';
import { useAuthContext } from 'context/AuthContext';
import Header from 'components/Header';
import Table from 'components/Table';
import './index.css';
import Dropdown3 from 'components/Dropdown3';

const TIME_CONSTRAINT = [
    {
        type: 'Standard',
        description: 'Simulates standard allotment',
        value: 1
    },
    {
        type: '50% Extra',
        description: 'Simulates 1.5x extended time accommodations',
        value: 1.5
    },
    {
        type: '100% Extra',
        description: 'Simulates 2x extended time accommodations',
        value: 2
    },
    {
        type: 'Untimed',
        description: 'Allows for practice with unlimitied time',
        value: 0
    },
]

const TEST_TYPE = { 'All': 'All', 'SAT': 'Digital SAT', 'PSAT': 'Digital PSAT', 'ACT': 'Digital ACT', 'SHSAT': 'Digital SHSAT', 'TSIA2': 'TSIA2', 'BCA': 'BCA' }
const TEST_TYPE_PAPER = { 'All': 'All', 'SAT': 'Digital SAT', 'PSAT': 'Digital PSAT', 'ACT': 'Digital ACT', 'SHSAT': 'Digital SHSAT', 'TSIA2': 'TSIA2', 'BCA': 'BCA', 'Paper ACT': 'Paper ACT' }

function LatestScores() {
    const navigate = useNavigate();
    const [tests, setTests] = useState([]);
    const [testType, setTestType] = useState(TEST_TYPE['All']);

    const { user } = useAuthContext();

    // Fetch once on mount. The request takes no parameters and the testType
    // dropdown filters client-side below, so depending on testType here only
    // re-fetched an identical payload -- an expensive no-op on this endpoint.
    useEffect(()=>{
        axios.get(`tutors/latestScores/`)
            .then(res => {
                setTests(res.data.tests);
            })
            .catch(error => {
                console.log(error);
        });
    }, []);

    const testTypes = user.customizations.find(customization => customization === 'Paper Test') ? TEST_TYPE_PAPER : TEST_TYPE;

    return (
        <div className='latestScores'>
            <Helmet>
                <title>
                    Latest Scores - Test Center Admin
                </title>
            </Helmet>
            <Header title='Latest Scores' />
            <div className='latestScores__buttons'>
                <Dropdown3
                    data={Object.keys(testTypes)}
                    value={testType}
                    onSelect={value => setTestType(value)}  
                />
            </div>  
            <Table 
                key={testType}
                header={['Student Name', 'Organization', 'Test Name', 'Section', 'Timing', 'Score', 'Test End Date', 'Report']}
                rows={tests.filter(test => testTypes[testType] === 'All' || test.testType === testTypes[testType]).map(test=>([
                    `${test.firstName} ${test.lastName}`,
                    test.organization,
                    test.testName,
                    test.testSection,
                    TIME_CONSTRAINT.find((option)=> option.value === parseFloat(test.timeExtension))?.type,
                    test.type === 'Digital SAT' || test.type === 'Digital PSAT'
                        ? test.score? Math.floor(test.score): '-'
                        : test.type === 'BCA'
                        // +2 / -0.5 per question: keep the half point and the sign.
                        ? (test.score != null ? Number(test.score) : '-')
                        : test.type === 'Digital ACT'
                        ? (test.compositeScore? Math.round(test.compositeScore): '-')
                        : test.type === 'Digital SHSAT'
                        ? (test.rawCorrect != null && test.totalQuestionCount ? `${test.rawCorrect} / ${test.totalQuestionCount}` : '-')
                        : test.type === 'TSIA2'
                        // Flat percent correct over what was served.
                        ? (test.score != null ? `${Math.round(test.score)}%` : '-')
                        : '-',
                    new Date(test.testDate).toLocaleDateString(),
                    'View'
                ]))}
                onSelectCell={tests.filter(test => testTypes[testType] === 'All' || test.testType === testTypes[testType]).map(test=>([
                    null,
                    null,
                    null,
                    null,
                    null,
                    null, 
                    null,
                    test.score && (
                        test.type === 'Digital SAT' || test.type === 'Digital PSAT'
                            ? () => navigate(`/report/digital-sat/${test.testId}`)
                            : test.type === 'BCA'
                            ? () => navigate(`/report/digital-bca/${test.testId}`)
                            : test.type === 'Digital ACT'
                            ? () => navigate(`/report/digital-act/${test.testId}`)
                            : test.type === 'Digital SHSAT'
                            ? () => navigate(`/report/digital-shsat/${test.testId}`)
                            : test.type === 'TSIA2'
                            ? () => navigate(`/report/digital-tsia2/${test.testId}`)
                            : test.type === 'Paper ACT'
                            ? () => navigate(`/report/paper-act/${test.testId}`)
                            : null
                    )
                ]))}
            />
        </div>
    );
}

export default LatestScores;